export default "__VITE_ASSET__BgZ0jsHY__"